export type DesktopSettings = Record<string, unknown>
export const isDesktopLocalOriginActive = () => false
export const isTauriShell = () => false
export const isVSCodeRuntime = () => false